<template>
  <b-modal
    ref="municipalityModal"
    size="xs"
    centered
    modal-class="municipality-modal"
    @hide="cleanData"
  >
    <div slot="modal-title">
      {{ actionTitle }} <span style="text-transform: lowercase">{{ $tc('configuration.sections.municipalities', 1) }}</span>
    </div>
    <b-row class="pt-2 pb-3 px-3">
      <b-col cols="12">
        <div class="form-label">
          <label>{{ $tc('configuration.sections.countries', 1) }}</label>
        </div>
        <vt-combo-select
          ref="countrySelect"
          v-model="country"
          track-by="id"
          label="name"
          ajax-search
          :internal-search="false"
          :option-loader="getCountries"
          @close="handleCloseCountrySelect"
        />
      </b-col>
      <b-col
        cols="12"
        class="mt-3"
      >
        <div class="form-label">
          <label>{{ $tc('configuration.sections.provinces', 1) }}</label>
        </div>
        <vt-combo-select
          ref="provinceSelect"
          v-model="province"
          track-by="id"
          label="name"
          ajax-search
          :internal-search="false"
          :disabled="!country"
          :option-loader="getProvinces"
          @close="handleCloseProvinceSelect"
        />
      </b-col>
      <b-col
        cols="12"
        class="mt-3"
      >
        <div class="form-label">
          <label>{{ $t('configuration.grid.externalCode') }}</label>
        </div>
        <vt-input
          ref="code"
          v-model="internalMunicipality.code"
          class="form-control-sm"
        />
      </b-col>
      <b-col
        cols="12"
        class="mt-3"
      >
        <div class="form-label">
          <label>{{ $tc('configuration.sections.municipalities', 1) }}</label>
        </div>
        <vt-input
          v-model="internalMunicipality.name"
          class="form-control-sm"
        />
      </b-col>
      <b-col
        cols="12"
        class="mt-3 d-flex justify-content-end"
      >
        <div class="switch-btn mt-1 p-0 d-flex align-items-center">
          <span
            v-if="internalMunicipality.active"
            class="mr-2"
          >{{ $t('configuration.actions.active') }}</span>
          <span
            v-else
            class="mr-2"
          >{{ $t('configuration.actions.inactive') }}</span>
          <input
            id="toggle"
            v-model="internalMunicipality.active"
            type="checkbox"
            class="offscreen"
            aria-hidden="true"
          >
          <label
            for="toggle"
            class="switch mb-0"
          />
        </div>
      </b-col>
    </b-row>
    <div
      slot="modal-footer"
      class="footer-banner px-2"
      style="width:100%;"
    >
      <div class="row">
        <div class="col-6 text-left">
          <b-button
            size="sm"
            variant="outline-secondary"
            data-dismiss="modal"
            @click="hide"
          >
            {{ $t('global.cancel') }}
          </b-button>
        </div>
        <div class="col-6 text-right">
          <b-button
            :disabled="disabledUpdateButton"
            size="sm"
            class="btn--primary"
            @click="update"
          >
            <i
              class="fal fa-check mr-2"
              aria-hidden="true"
            />
            {{ actionTitle }}
          </b-button>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { isEmpty } from 'lodash'
import ProvinceConfigurationServices from '@/api/resources/configuration/demography/province/ProvinceConfigurationServices'
import CountryConfigurationServices from '@/api/resources/configuration/demography/country/CountryConfigurationServices'
import { GridUtils } from '@/shared/util/grid-utils'

export default {
    name: 'MunicipalityModal',
    props: {
        actionTitle: String
    },
    data() {
        return {
            internalMunicipality: {},
            province: null,
            country: null
        }
    },
    computed: {
        disabledUpdateButton() {
            return !this.internalMunicipality.code || !this.internalMunicipality.name || !this.province?.id || !this.province?.country
        }
    },
    methods: {
        show(selectedMunicipality) {
            if (selectedMunicipality && !isEmpty(selectedMunicipality)) {
                this.internalMunicipality = {
                    active: selectedMunicipality.active,
                    code: selectedMunicipality.code,
                    provinceId: selectedMunicipality.province.id,
                    id: selectedMunicipality.id,
                    name: selectedMunicipality.name
                }
                this.country = selectedMunicipality.province?.country
                this.province = selectedMunicipality.province
            } else {
                this.cleanData()
            }
            this.$refs.municipalityModal.show()
        },
        hide() {
            this.$refs.municipalityModal.hide()
        },
        update() {
            this.internalMunicipality.provinceId = this.province.id
            if (this.internalMunicipality.id) this.$emit('update', this.internalMunicipality)
            else this.$emit('create', this.internalMunicipality)
        },
        cleanData() {
            this.internalMunicipality = {
                active: true,
                code: '',
                name: ''
            }
            this.province = null
            this.country = null
            this.$refs.countrySelect?.clearInternalOptions()
            this.$refs.provinceSelect?.clearInternalOptions()
        },
        handleCloseCountrySelect() {
            this.$refs.countrySelect?.clearInternalOptions()
        },
        handleCloseProvinceSelect() {
            this.$refs.provinceSelect?.clearInternalOptions()
        },
        async getProvinces(query) {
            if (query) {
                const filterModel = {
                    'country.id': GridUtils.getNumberFilterModel('equals', this.country.id),
                    'name': GridUtils.getTextFilterModel('contains', query),
                    'active': GridUtils.getSetFilterModel(['true'])
                }
                const paginator = await ProvinceConfigurationServices.paginator(filterModel)
                return paginator.content
            }
            return []
        },
        async getCountries(query) {
            if (query) {
                const filterModel = {
                    'name': GridUtils.getTextFilterModel('contains', query),
                    'active': GridUtils.getSetFilterModel(['true'])
                }
                const paginator = await CountryConfigurationServices.paginator(filterModel)
                return paginator.content
            }
            return []
        }
    }
}
</script>
